module.exports = __webpack_public_path__ + "static/media/hard_dollars_4.7d3ff571.png";